import Component from "@ember/component"

export default class BlankTemplate extends Component {}
